<template>
  <div>

    <!-- Header Area -->
    <div class="header-area" id="headerArea">
      <div class="container">
        <div class="header-content header-style-five position-relative d-flex align-items-center justify-content-between">
          <!-- Logo -->
          <div class="logo-wrapper"><a href="/home"><img :src="$urlUploads + userData.user.siteLogo" alt=""></a></div>
          <!-- Back Button -->
          <div v-if="urlBack" class="back-button">
            <a :href="urlBack"><i class="fas fa-chevron"></i></a>
          </div>
          <!-- Page Title -->
          <div class="page-heading">
            <h6 class="mb-0">{{title}}</h6>
          </div>
          <!-- Navbar Toggler -->
          <div class="navbar--toggler" id="affanNavbarToggler" data-bs-toggle="offcanvas" data-bs-target="#affanOffcanvas" aria-controls="affanOffcanvas"><span class="d-block"></span><span class="d-block"></span><span class="d-block"></span></div>
        </div>
      </div>
    </div>

    <!-- Offcanvas -->
    <div class="offcanvas offcanvas-start" id="affanOffcanvas" data-bs-scroll="true" tabindex="-1" aria-labelledby="affanOffcanvsLabel">
      <button class="btn-close btn-close-white text-reset" type="button" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      <div class="offcanvas-body p-0">
        <div class="sidenav-wrapper">
          <div class="sidenav-profile bg-rbo">
            <div class="sidenav-style1"></div>
            <!-- User -->
            <div v-if="loggedIn">
                <img src="/img/avatar.png" class="avatar-img rounded-circle" alt="photo">
                <div class="user-info">
                  <h6 class="user-name mb-0 mt-3">{{userData.user.firstName}} {{userData.user.lastName}}</h6>
                  <p v-if="userData.user.siteNom" class="text-white">{{ userData.user.siteNom }}</p>
                </div>
            </div>
            <!-- Logo -->
            <div v-if="!loggedIn" class="container">
                  <div>
                   <img src="" class="" alt="photo" style="max-height: 200px;">
                  </div>
            </div>
          </div>

          <!-- Sidenav Nav -->
          <ul class="sidenav-nav ps-0">
            <li><a href="/home"><i class="fas fa-home"></i>Accueil</a></li>
            <li><a href="/entreprise"><i class="fas fa-briefcase"></i>Mon compte</a></li>
            <li><a href="/crm"><i class="fas fa-users"></i>Annuaire</a></li>
            <li><a href="/vente"><i class="fas fa-euro-sign"></i>Ventes</a></li>
            <li><a href="/vehicules"><i class="fas fa-car"></i>Véhicules</a></li>

            <li v-if="!loggedIn"><a href="/login"><i class="fas fa-sign-in-alt"></i>Connexion</a></li>
            <li v-if="loggedIn"><a href="/login" @click.prevent="logOut"><i class="fas fa-sign-out-alt"></i>Déconnexion</a></li>
            <li v-if="loggedIn"><a href="/home" @click.prevent="deleteCaches"><i class="fas fa-trash"></i>Supprimer le cache</a></li>
            <li v-if="loggedIn && isNotificationPermission == false"><a href="#" @click.prevent="askNotificationPermission" id="notificationBtn"><i class="fas fa-dot-circle"></i>Autoriser les notifications</a></li>

          </ul>
          
          <!-- Social Info -->
          <div class="social-info-wrap">
            <a href="https://facebook.com" target="_blank"><i class="bi bi-facebook"></i></a>
            <a href="https://linkedin.com" target="_blank"><i class="bi bi-linkedin"></i></a>
            <a href="https://twitter.com" target="_blank"><i class="bi bi-twitter"></i></a>
          </div>
          
          <!-- Copyright Info -->
          <div class="copyright-info">
            <p>
                &copy; 2024-
                Application développée
                par<a href="https://www.betterb.fr" target="_blank">BetterB</a>
                - Version {{version}}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import '../services/notifications.js';
export default {
  name: 'Header',
  props: ['title', 'urlBack'],
  data: function() {
    return {
        version: this.$version,
        loggedIn: this.$store.state.auth.status.loggedIn,
        userData: [],
        isNotificationPermission: false,
    }
  },
  filters: {
    formatDecimal: function (value) {
      if (!value) return '0'
      value = (value).toFixed(2);
      return value;
    }
  }, 
  async created() {
    if (localStorage.getItem('userData')) {
      this.userData = JSON.parse(localStorage.getItem('userData'));
    }

    if (Notification?.permission === "granted") {
      this.isNotificationPermission = true;
    }
  
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    deleteCaches() {
      const staticCacheName = 'cache-v' + this.$version;
      const dynamicCacheName = 'runtimeCache-v' + this.$version;
      caches.delete(staticCacheName).then(function() {});
      caches.delete(dynamicCacheName).then(function() {});
      this.$router.go();
    },
    askNotificationPermission() {
      // On vérifie si le navigateur prend en charge les notifications
      if (!("Notification" in window) && !('serviceWorker' in navigator)) {
        console.log("This browser does not support notifications.");
        return;
      }
      Notification.requestPermission().then((permission) => {
        // On affiche ou non le bouton en fonction de la réponse
        var notificationBtn = document.getElementById('notificationBtn');
        notificationBtn.style.display = permission === "granted" ? "none" : "block";
      });
    }
  }
}
</script>

<style>
.header-title {
    color: #153760;
    padding-top: 0.4rem;
    font-weight: bold;
}
h6 {
    font-size: 1.2rem;
    font-weight: bolder;
}
</style>